import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const Subheader = ({ title, headerToolbar, subTitle, sx }) => (
	<Stack sx={sx}>
		<Grid
			container
			sx={{
				alignItems: 'center',
				justifyContent: 'space-between',
			}}
		>
			<Grid>
				<Typography variant="h4" color="text.primary">
					{title}
				</Typography>
			</Grid>
			<Grid align="right">{headerToolbar}</Grid>
		</Grid>
		{subTitle && (
			<Typography variant="subtitle2" color="text.primary">
				{subTitle}
			</Typography>
		)}
	</Stack>
);

Subheader.propTypes = {
	headerToolbar: PropTypes.element,
	subTitle: PropTypes.string,
	sx: PropTypes.object,
	title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
};

export default Subheader;
